module.exports = __webpack_public_path__ + "img/banner-principal.4387cc4b.png";